import React from 'react';
import {Routes, Route} from 'react-router-dom';
import {useSelector} from "react-redux";
import AppHook from "./AppHook";
import QuestionnaireImportHook from "./components/qd/questionnaires/QuestionnaireImportHook";
import IntegrationListHook from "./components/templateList/IntegrationListHook";
import IntegrationLogsListHook from "./components/templateList/IntegrationLogsListHook";
import QuestionnaireList from "./components/templateList/QuestionnaireListHook";
import CategoryListMuiExample from "./components/templateList/CategoryListHook";
import GroupList from "./components/templateList/GroupListHook";
import QuestionListHook from "./components/templateList/QuestionListHook";
import ActionListHook from "./components/templateList/ActionListHook";
import TemplateVersionsListHook from "./components/templateList/TemplateVersionsListHook";
import QuestionnaireContainerHook from "./components/qd/questionnaires/QuestionnaireContainerHook";
import CategoryContainerHook from "./components/qd/categories/CategoryContainerHook";
import GroupContainerHook from "./components/qd/groups/GroupContainerHook";
import QuestionContainerHook from "./components/qd/questions/QuestionContainerHook";
import ActionContainerHook from "./components/qd/actions/ActionContainerHook";
import TagListHook from "./components/templateList/TagListHook";
import NoPage from "./components/common/NoPage";
import MainDrawerHook from "./components/drawers/MainDrawerHook";
import ArgoAppSnackbarHook from "./components/common/ArgoAppSnackbarHook";
import PortalContainer from "./portal/PortalContainerHook";
import {QD_URL, REACT_APP_PORTAL_MODE, QD_PORTAL} from "./constants/systemConstants";
import ChangeAppTitleToPortalHook from "./portal/utilities/ChangeAppTitleToPortalHook"
import * as TEMPLATE from "./constants/templateConstants";
import SignedOutPage from "./components/common/SignedOutPage";


const Router = () => {
    // eslint-disable-next-line no-unused-vars
    const theme = useSelector(state => state.portalTheme);

    let location = window.location; // Get URL

    return (
        <div>
            {REACT_APP_PORTAL_MODE === "true" ?
                <>
                    <Routes>
                        <Route path={"/"} element={<AppHook location={location} portalMode={REACT_APP_PORTAL_MODE}/>}>
                            <Route index element={<PortalContainer/>}/>
                            <Route path={QD_PORTAL} element={<PortalContainer/>}/>
                            <Route path={QD_PORTAL + "/:key"} element={<PortalContainer/>}/>
                            <Route path="/signed-out" element={<SignedOutPage/>}/>
                            <Route path="*" element={<NoPage/>}/>
                        </Route>
                    </Routes>
                </>
                :
                <div>
                    <Routes>

                        <Route path={"/"} element={<AppHook location={location}/>}>
                            <Route index element={<QuestionnaireList/>}/>
                            <Route path={QD_URL + "/questionnaires"} element={<QuestionnaireList/>}/>
                            <Route path={QD_URL + "/questionnaire-editor"} element={<QuestionnaireContainerHook/>}/>
                            <Route path="/signed-out" element={<SignedOutPage/>}/>
                            <Route path={QD_URL + "/questionnaire-editor/:templateKey/:templateId/:mode"} element={<QuestionnaireContainerHook/>}/>
                            <Route path={QD_URL + "/categories"} element={<CategoryListMuiExample/>}/>
                            <Route path={QD_URL + "/category-editor/:templateKey"} element={<CategoryContainerHook/>}/>
                            <Route path={QD_URL + "/groups"} element={<GroupList/>}/>
                            <Route path={QD_URL + "/group-editor/:templateKey"} element={<GroupContainerHook/>}/>
                            <Route path={QD_URL + "/questions"} element={<QuestionListHook/>}/>
                            <Route path={QD_URL + "/question-editor/:templateKey"} element={<QuestionContainerHook/>}/>
                            <Route path={QD_URL + "/actions"} element={<ActionListHook/>}/>
                            <Route path={QD_URL + "/action-editor/:templateKey"} element={<ActionContainerHook/>}/>
                            <Route path={QD_URL + "/import"} element={<QuestionnaireImportHook/>}/>
                            <Route path={QD_URL + "/integrations"} element={<IntegrationListHook/>}/>
                            <Route path={QD_URL + "/integration-logs/:id"} element={<IntegrationLogsListHook/>}/>
                            <Route path={QD_URL + "/questionnaire-versions/:templateKey"}
                                   element={<TemplateVersionsListHook templateType={TEMPLATE.TYPE.QUESTIONNAIRE}
                                                                  templateMode={TEMPLATE.MODE.VERSIONS}/>}/>
                            <Route path={QD_URL + "/category-versions/:templateKey"}
                                   element={<TemplateVersionsListHook templateType={TEMPLATE.TYPE.CATEGORY}
                                                                  templateMode={TEMPLATE.MODE.VERSIONS}/>}/>
                            <Route path={QD_URL + "/group-versions/:templateKey"}
                                   element={<TemplateVersionsListHook templateType={TEMPLATE.TYPE.GROUP}
                                                                  templateMode={TEMPLATE.MODE.VERSIONS}/>}/>
                            <Route path={QD_URL + "/question-versions/:templateKey"}
                                   element={<TemplateVersionsListHook templateType={TEMPLATE.TYPE.QUESTION}
                                                                  templateMode={TEMPLATE.MODE.VERSIONS}/>}/>
                            <Route path={QD_URL + "/action-versions/:templateKey"}
                                   element={<TemplateVersionsListHook templateType={TEMPLATE.TYPE.ACTION}
                                                                  templateMode={TEMPLATE.MODE.VERSIONS}/>}/>
                            <Route path={QD_URL + "/search-tags"} element={<TagListHook/>}/>
                            <Route path="*" element={<NoPage/>}/>
                        </Route>
                    </Routes>
                </div>
            }

            <ChangeAppTitleToPortalHook mode={REACT_APP_PORTAL_MODE}/>

            <MainDrawerHook/>

            <ArgoAppSnackbarHook/>

        </div>
    );
}

export default Router;


// index tells react-router that it should render the provided element when you are at the index of the route.

// Good react route article
// https://reactrouter.com/en/v6.3.0/getting-started/concepts
// https://reactrouter.com/en/v6.3.0/getting-started/concepts#index-routes

// https://reactrouter.com/en/v6.3.0/getting-started/concepts#index-route

// https://stackoverflow.com/questions/42253277/react-router-v4-how-to-get-current-route

// import { useLocation } from 'react-router-dom';
//
// const ExampleComponent: React.FC = () => {
//     const location = useLocation();
//
//     return (
//         <Router basename='/app'>
//             <main>
//                 <AppBar handleMenuIcon={this.handleMenuIcon} title={location.pathname} />
//             </main>
//         </Router>
//     );
// }